module.exports = __webpack_public_path__ + "static/media/agricultural17.553609f0.jpg";